<template>
  <div class="Apply">
    <img src="../../assets/images/live_bgimg.png" class="info-img" alt="" />
    <div class="out-bg">
      <div class="form-content">
        <h3>免费听课，立即预约</h3>
        <van-form @submit="onSubmit">
          <van-field
            v-model="phone"
            left-icon="phone-circle-o"
            name="phone"
            placeholder="手机号"
            :rules="[
              { required: true, message: '请输入手机号' },
              { validator, message: '请输入正确的手机号' },
            ]"
          />
          <van-field
            v-model="telCode"
            type="tel"
            left-icon="passed"
            name="telCode"
            placeholder="验证码"
            maxlength="6"
            :rules="[{ required: true, message: '请输入验证码' }]"
          >
            <template #button>
              <van-button
                :disabled="btnDisable"
                @click.stop="getMobileCaptchaForRegister"
                size="small"
                type="primary"
                >{{ btnText }}</van-button
              >
            </template></van-field
          >
          <div class="look-btn">
            <van-button block type="info" native-type="submit"
              >观看直播</van-button
            >
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>
<script>
import { Notify, Toast } from "vant";
import { sendSms, saveuser, chatauthurl, getUserId } from "@/server/api.js";
import { getParams } from "../../utils/public";
export default {
  data() {
    return {
      phone: "",
      telCode: "",
      btnText: "获取短信验证码",
      yztime: 60,
      btnDisable: false,
      qyuserId: "",

      userId: "",
      wechatUserId: "",
      windowurl: "",
    };
  },
  created() {
    document.title = "千锋教育";
  },
  mounted() {
    this.windowurl =
      window.location.href.split("#")[0] || "http://tm-qw1000.phone.net/apply";
    let paramsObj = getParams(window.location.search);
    if (window.location.search && paramsObj.userId && !paramsObj.code) {
      // 授权获取userId
      this.linkAuthtj();
    } else if (window.location.search && paramsObj.code) {
      this.getUserIdCode(); // 获取code
    }
  },
  methods: {
    linkAuthtj() {
      chatauthurl({ authurl: this.windowurl }).then((res) => {
        if (res.code == "200") {
          window.location.href = res.data;
        }
      });
    },
    async getUserIdCode() {
      let code = getParams(window.location.search).code;
      let res = await getUserId({ code: code });
      this.wechatUserId = res.data;
    },
    getMobileCaptchaForRegister(e) {
      e.preventDefault();
      if (!this.phone)
        return Notify({ type: "danger", message: "请输入手机号" });
      sendSms({ tel: this.phone }).then((res) => {
        if (res.code !== "200")
          return Notify({ type: "danger", message: res.msg });
        Notify({ type: "success", message: res.msg });
        let timeObj = setInterval(() => {
          this.yztime = this.yztime - 1;
          console.log(this.yztime);
          this.btnText = this.yztime + "秒后重新获取";
          this.btnDisable = true;
          if (this.yztime <= 0) {
            (this.btnText = "获取短信验证码"),
              (this.btnDisable = false),
              (this.yztime = 60);
            clearInterval(timeObj);
            return;
          }
        }, 1000);
      });
    },
    onSubmit() {
      let activityId = getParams(window.location.search).xetId;
      let qyuserId = getParams(window.location.search).userId;
      // this.userId = localStorage.getItem("userid");
      let params = {
        activityId,
        qyuserId,
        userId: this.wechatUserId,
        userPhone: this.phone,
        telCode: this.telCode,
      };
      saveuser(params).then((res) => {
        if (res.code !== "200") return Toast.fail(res.msg);
        Toast.success(res.msg);
        let u = navigator.userAgent;
        let android = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
        let ios = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if (android) {
          window.open(res.data);
        } else if (ios) {
          window.location.href = res.data;
        } else {
          window.open(res.data);
        }
      });
    },
    validator(val) {
      return /^1(3|4|5|6|7|8|9)\d{9}$/.test(val);
    },
  },
};
</script>

<style scoped lang="less">
.Apply {
  height: 100vh;
  display: flex;
  flex-direction: column;
  .info-img {
    width: 100%;
  }
  .out-bg {
    flex: 1;
    background: linear-gradient(182deg, #001fee 0%, #92a8ff 100%);
  }
  .form-content {
    height: 100%;
    h3 {
      font-size: 36px;
      margin-bottom: 20px;
      color: #2e63ff;
    }
    margin: -25px 28px 20px;
    background-color: #fff;
    border-radius: 10px;
    padding: 30px 20px 150px;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
    width: calc(100% - 58px);
    .van-cell {
      padding-left: 0;
      margin-bottom: 40px;
    }
    .look-btn {
      margin-top: 90px;
      button {
        height: 80px;
        background: linear-gradient(90deg, #6b89fb 0%, #2e63ff 100%);
      }
    }
    /deep/.van-icon-passed {
      padding-top: 4px;
    }
    .van-field__button {
      button {
        background: #277fff;
        border: solid 1px #277fff;
      }
    }
  }
}
</style>
